import { keysToSnake } from '#/api/adapters/wireCase';

function emptyToNull(value) {
  if (value == null) {
    return null;
  }
  const trimmed = String(value).trim();
  return trimmed === '' ? null : trimmed;
}

/**
 * 新增：不送 status。customer_id 可為 null。
 *
 * @param {object} values
 */
export function toSnProductMappingCreateBody(values = {}) {
  return {
    customerId: emptyToNull(values.customerId),
    productCode: emptyToNull(values.productCode),
    productName: emptyToNull(values.productName),
    remark: emptyToNull(values.remark),
  };
}

/**
 * 修改：一律帶 updatedAt、名稱、備註。
 * 待指定才送 customerId（可 null）與 productCode。啟用／停用不送客戶。
 *
 * @param {object} values
 */
export function toSnProductMappingUpdateBody(values = {}) {
  const body = {
    productName: emptyToNull(values.productName),
    remark: emptyToNull(values.remark),
    updatedAt: values.updatedAt ?? values.record?.updatedAt ?? null,
  };

  if (!values.identityLocked) {
    body.customerId = emptyToNull(values.customerId);
    body.productCode = emptyToNull(values.productCode);
  }

  return body;
}

/**
 * 啟用／停用只送 updated_at。
 *
 * @param {object} values
 */
export function toSnProductMappingCommandBody(values = {}) {
  return {
    updatedAt: values.updatedAt ?? values.record?.updatedAt ?? null,
  };
}

export function serializeSnProductMappingCreate(values) {
  return keysToSnake(toSnProductMappingCreateBody(values));
}

export function serializeSnProductMappingUpdate(values) {
  return keysToSnake(toSnProductMappingUpdateBody(values));
}

export function serializeSnProductMappingCommand(values) {
  return keysToSnake(toSnProductMappingCommandBody(values));
}
